/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  api.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Dec 12, 2019
 *
 * @Version      : Version 1.0
 *
 * By            	: Madhu Gali (H175591)
 * On            	: Dec 12, 2019
 * Description   	: ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 27, 2020
 * Description   : ASDS-2356 CheckOut Forge QA Environment validation
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 * By            : H422335
 * On            : Dec 02, 2020
 * Description   : Redirecting user to Generic Error page when check-asds-access call returns 403
 ******************************************************************************/
import axios from 'axios';
import { getAccessToken, getProperty, evaluateCurrentEnv } from "../../../utils/util";
import { logError } from '../../../utils/console-utility';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import UserValidationAction from '../redux/actions/userDetailsActions';

export const getBaseURL = () => {
    let baseURL = getProperty(CheckoutServiceURL.BACKEND_BASE_URL);
    return baseURL;

}

evaluateCurrentEnv(window.location.href);
var instance = axios.create({
    baseURL: getBaseURL(),
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        // Authorization: getAccessToken()?.toString()
        }
});

const onRequestSuccess = config => {
    let token = {
        toString() {
            return getAccessToken();
        }
    };
    config.headers['Authorization'] = token;
    return config;
};

const onRequestError = error => {
    logError(error);
    return Promise.reject(error);
};

instance.interceptors.request.use(onRequestSuccess, onRequestError);

// for multiple requests
let isRefreshing = false;
let failedQueue: any = [];

const processQueue = () => {
    let token = {
        toString() {
            return getAccessToken();
        }
    };
    failedQueue.forEach(prom => {
        prom.config.headers['Authorization'] = token;
        (axios(prom.config));
    });

    failedQueue = [];
};

// interceptor to handle error in each and every API call
// if it is 401 error then it will get the access token using refresh token
// if it is 403 then it will redirect to /accessDenied page
instance.interceptors.response.use(response => response, error => {
    const status = error.response ? error.response.status : null
    const originalRequest = error.config;
    if (status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
            failedQueue.push(error);
            return Promise.reject();
        } else {
            originalRequest._retry = true;
            isRefreshing = true;
            return new Promise(function (resolve, reject) {

                return UserValidationAction.refreshToken().then(_ => {
                    let token = {
                        toString() {
                            return getAccessToken();
                        }
                    };
                    error.config.headers['Authorization'] = token;
                    resolve(axios(error.config));
                    processQueue();
                }).catch((err) => {
                    reject(err);
                })
                    .then(() => { isRefreshing = false; });
            });
        }

    } else if (status === 403) {
        // window.location.href = '/accessDenied';  => No component to handle this route as of now. Hence removing. Instead user will land on default errorpage.
    }

    return Promise.reject(error);
});

export default instance;